export default __webpack_public_path__ + "static/media/warning.56b979e4.svg";